import { HeymergeVaultContent } from 'heymerge';
import {
  recursivelyTransformValues,
  ISODateString,
  ProtectedValue,
  Unprotect,
  UnprotectedValue,
} from 'persistable-types';

export function modifyProtectedValues<T extends HeymergeVaultContent<Record<string, unknown>>>(
  content: HeymergeVaultContent<Record<string, unknown>>,
  timestamp: ISODateString,
  transform: (pv: ProtectedValue) => ProtectedValue,
): T {
  let modifiedContent = content;
  for (const [listKey, list] of Object.entries(content)) {
    for (const [elementKey, current] of Object.entries(list)) {
      const modifiedElement = {
        ...recursivelyTransformProtectedValues(current, transform),
        updateTime: timestamp,
      };

      modifiedContent = {
        ...modifiedContent,
        [listKey]: { ...modifiedContent[listKey], [elementKey]: modifiedElement },
      };
    }
  }
  return modifiedContent as T;
}

export function recursivelyTransformProtectedValues<T, E>(
  element: E,
  transform: (pv: ProtectedValue) => T,
): Unprotect<E, T> {
  return recursivelyTransformValues(element, isProtectedValue, transform) as Unprotect<E, T>;
}

export function recursivelyTransformUnprotectedValues<T, E>(
  element: unknown,
  transform: (upv: UnprotectedValue) => T,
): Unprotect<E, T> {
  return recursivelyTransformValues(element, isUnprotectedValue, transform) as Unprotect<E, T>;
}

function isProtectedValue(obj: object): obj is ProtectedValue {
  return ProtectedValue.validate(obj);
}

export function isUnprotectedValue(obj: object): obj is UnprotectedValue {
  return UnprotectedValue.validate(obj);
}
